// types
import { IAction } from 'types/action';

// actions
import { WIDGET_ACTIVE_VIEW_TRANSITION } from './router.constants';

export interface IState {
    currentView: string | null;
}

export const initialState: IState = {
    currentView: null
};

export const reducerKey = 'router';

export const routerHOF = (_initialState = initialState) => (state = _initialState, action: IAction): IState => {
    switch (action.type) {
    case WIDGET_ACTIVE_VIEW_TRANSITION:
        return {
            currentView: action.payload
        };
    default:
        return state;
    }
};

export default routerHOF;
